import React from "react";

const DashboardCustomizeButton = () => (
  <button
    className="btn w-100 py-3 lato-bold-25u  h-100 d-flex flex-column align-items-center justify-content-center"
    style={{
      background: "#ff1be6",
      color: "#fff",
      fontSize: 16,
      border: "none",
      borderRadius: 12,
    }}
  >
    Customize Dashboard
  </button>
);

export default DashboardCustomizeButton;
